import { modules } from '@veritone/glc-redux';
const {
  config: { getConfig },
} = modules;

const getDefaultEngineId = (state: any) => {
  const config = getConfig<Window['config']>(state);
  return config.defaultEngineId;
};
export default getDefaultEngineId;
